import React, { forwardRef, useEffect, useRef, useState } from "react";
import {AtSign, Calendar, GitHub, Linkedin, MapPin, Paperclip, Phone} from "react-feather";
// import { Document, Page, PDFViewer } from 'react-pdf';
import stylesOneColumn from "./Templates/oneColumn.module.css";
import stylesTwoColumn from "./Templates/twoColumn.module.css";

const Resume = forwardRef((props, ref) => {
  const information = props.information;
  const sections = props.sections;
  const containerRef = useRef();

  const [columns, setColumns] = useState([[], []]);
  const [source, setSource] = useState("");
  const [target, seTarget] = useState("");
  const [styles, setStyles] = useState(stylesTwoColumn);


  const info = {
    workExp: information[sections.workExp],
    project: information[sections.project],
    achievement: information[sections.achievement],
    education: information[sections.education],
    basicInfo: information[sections.basicInfo],
    skill: information[sections.skill],
    course: information[sections.course],
    por: information[sections.por],
  };

  const getFormattedDate = (value) => {
    if (!value) return "";
  
    const date = new Date(value);
    const monthName = date.toLocaleString("en-US", { month: "short" }); // Gets "Jan", "Feb", etc.
    const year = date.getFullYear();
  
    return `${monthName} ${year}`;
  };

  const sectionDiv = {
    [sections.workExp]: info.workExp?.details.length > 0 ? (
      <div
        key={"workexp"}
        draggable
        onDragOver={() => seTarget(info.workExp?.id)}
        onDragEnd={() => setSource(info.workExp?.id)}
        className={`${styles.section} ${
          info.workExp?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.workExp.sectionTitle}</div>
        <div className={styles.content}>
          {info.workExp?.details?.map((item, itemIndex) => (
            <div className={styles.item} key={`work:${itemIndex}`}>
              <div className = {styles.contentHeader}>
                <div className={styles.headerRow}>
                  {item.title ? (
                    <p className={styles.title}>{item.title}</p>
                  ) : (
                    <span />
                  )}
                  {item.startDate && item.endDate ? (
                    <div className={styles.date}>
                      <Calendar className={styles.svg}/> {`${getFormattedDate(item.startDate)} -- ${getFormattedDate(item.endDate)}`}
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
                <div className={styles.headerRow}>
                    {item.companyName ? (
                      <p className={styles.overview}>{item.companyName}</p>
                    ) : (
                      <span />
                    )}

                    {item.location ? (
                      <p className={styles.date}>
                        <MapPin className={styles.svg}/> {item.location}
                      </p>
                    ) : (
                      <span />
                    )}         
                </div>
              </div>
              {item.points?.length > 0 ? (
                <ul className={styles.points}>
                  {item.points?.map((elem, pointIndex) => (
                    elem.length > 0?
                    <li className={styles.point} key={`work:${itemIndex} ${pointIndex}`}>
                      {elem}
                    </li>:<span/>
                  ))}
                </ul>
              ) : (
                <span />
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null,
    [sections.project]: info.project?.details.length > 0 ? (
      <div
        key={"project"}
        draggable
        onDragOver={() => seTarget(info.project?.id)}
        onDragEnd={() => setSource(info.project?.id)}
        className={`${styles.section} ${
          info.project?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.project.sectionTitle}</div>
        <div className={styles.content}>
          {info.project?.details?.map((item, itemIndex) => (
            <div className={styles.item} key={`project:${itemIndex}`}>
              <div className={styles.contentHeader}>
                <div className={styles.headerRow}>
                  {/* project title */}
                  <div className={styles.projectHeading}>
                    {item.title ? (
                      <p className={styles.title}>{item.title}</p>
                    ) : (
                      <span />
                    )}

                    {item.link ? (
                      <a className={styles.link} href={item.link} target="_blank" rel="noreferrer">
                        <Paperclip className={styles.svg}/>
                        Link
                      </a>
                    ) : (
                      <span />
                    )}
                    {item.github ? (
                      <a className={styles.link} href={item.github} target="_blank" rel="noreferrer">
                        <GitHub className={styles.svg}/>
                        Github
                      </a>
                    ) : (
                      <span />
                    )}
                  </div>
                  {/* project duration */}
                  {item.startDate && item.endDate ? (
                    <div className={styles.date}>
                      <Calendar className={styles.svg}/> {`${getFormattedDate(item.startDate)} -- ${getFormattedDate(item.endDate)}`}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.headerRow}>
                  {item.overview ? (
                    <p className={styles.overview}>{item.overview} </p>
                  ) : (
                    <span />
                  )}
                </div>
            </div>
              {item.points?.length > 0 ? (
                <ul className={styles.points}>
                  {item.points?.map((elem, pointIndex) => (
                    elem.length > 0?
                    <li className={styles.point} key={`project:${itemIndex} ${pointIndex}`}>
                      {elem} 
                    </li>:<span/>
                  ))}
                </ul>
              ) : (
                <span />
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null,
    [sections.education]: info.education?.details.length > 0 ? (
      <div
        key={"education"}
        draggable
        onDragOver={() => seTarget(info.education?.id)}
        onDragEnd={() => setSource(info.education?.id)}
        className={`${styles.section} ${
          info.education?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>
          {info.education?.sectionTitle}
        </div>
        <div className={styles.content}>
          {info.education?.details?.map((item, itemIndex) => (
            <div className={styles.item} key={`education:${itemIndex}`}>
              <div className={styles.contentHeader}>
                <div className={styles.headerRow}>
                  {item.title ? (
                    <p className={styles.title}>{item.title}</p>
                  ) : (
                    <span />
                  )}

                  {item.startDate && item.endDate ? (
                    <div className={styles.date}>
                      <Calendar className={styles.svg}/> {`${getFormattedDate(item.startDate)} -- ${getFormattedDate(item.endDate)}`}
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className={styles.headerRow}>
                  {item.college ? (
                    <p className={styles.overview}>{item.college}</p>
                  ) : (
                    <span />
                  )}
                    {item.result ? (
                      <div className={styles.overview}>{item.result}</div>
                    ) : (
                      ""
                    )}
                </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    ) : null,
    [sections.skill]: info.skill?.details.length > 0 ? (
      <div
        key={"skill"}
        draggable
        onDragOver={() => seTarget(info.skill?.id)}
        onDragEnd={() => setSource(info.skill?.id)}
        className={`${styles.section} ${
          info.skill?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.skill?.sectionTitle}</div>
        <div className={styles.content}>
          {info.skill?.details?.map((item, itemIndex) => (
            <div className={styles.skillContainer} key={`skill:${itemIndex}`}>
              {item.title ? (
                <p className={styles.title}>{item.title}</p>
              ) : (
                <span />
              )}
              {item.points?.length > 0 ? (
                <div className={styles.skillPoints}>
                  {item.points?.map((elem, pointIndex) => (
                    elem.length > 0?
                    (<div className={styles.skill} key={`skill:${itemIndex} ${pointIndex}`}>
                      {elem}
                    </div>):(<span/>)
                  ))}
                </div>
              ) : (
                <span />
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null,
    [sections.course]: info.course?.points?.length > 0 ? (
      <div
        key={"course"}
        draggable
        onDragOver={() => seTarget(info.course?.id)}
        onDragEnd={() => setSource(info.course?.id)}
        className={`${styles.section} ${
          info.course?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.course?.sectionTitle}</div>
        <div className={styles.content}>
          {info.course?.points?.length > 0 ? (
            <ul className={styles.courseContainer}>
              {info.course?.points?.map((elem, index) => (
                elem.length > 0?
                <li className={styles.course} key={`course:${index}`}>
                  {elem}
                </li>:<span/>
              ))}
            </ul>
          ) : (
            <span />
          )}
        </div>
      </div>
    ) : null,
    [sections.achievement]: info.achievement?.points?.length ? (
      <div
        key={"achievement"}
        draggable
        onDragOver={() => seTarget(info.achievement?.id)}
        onDragEnd={() => setSource(info.achievement?.id)}
        className={`${styles.section} ${
          info.achievement?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.achievement?.sectionTitle}</div>
        <div className={styles.content}>
          {info.achievement?.points?.length > 0 ? (
            <ul className={styles.points}>
              {info.achievement?.points?.map((elem, index) => (
                elem.length > 0?
                <li className={styles.point} key={`achievement:${index}`}>
                  {elem}
                </li>:<span/>
              ))}
            </ul>
          ) : (
            <span />
          )}
        </div>
      </div>
    ) : null,
    [sections.por]: info.por?.points?.length > 0 ? (
      <div
        key={"por"}
        draggable
        onDragOver={() => seTarget(info.por?.id)}
        onDragEnd={() => setSource(info.por?.id)}
        className={`${styles.section} ${
          info.por?.sectionTitle ? "" : styles.hidden
        }`}
      >
        <div className={styles.sectionTitle}>{info.por?.sectionTitle}</div>
        <div className={styles.content}>
          {info.por?.points?.length > 0 ? (
            <ul className={styles.points}>
              {info.por?.points?.map((elem, index) => (
                elem.length > 0?
                <li className={styles.point} key={`por:${index}`}>
                  {elem}
                </li>:<span/>
              ))}
            </ul>
          ) : (
            <span />
          )}
        </div>
      </div>
    ) : null,
  };

  const swapSourceTarget = (source, target) => {
    if (!source || !target) return;
    const tempColumns = [[...columns[0]], [...columns[1]]];

    let sourceRowIndex = tempColumns[0].findIndex((item) => item === source);
    let sourceColumnIndex = 0;
    if (sourceRowIndex < 0) {
      sourceColumnIndex = 1;
      sourceRowIndex = tempColumns[1].findIndex((item) => item === source);
    }

    let targetRowIndex = tempColumns[0].findIndex((item) => item === target);
    let targetColumnIndex = 0;
    if (targetRowIndex < 0) {
      targetColumnIndex = 1;
      targetRowIndex = tempColumns[1].findIndex((item) => item === target);
    }

    const tempSource = tempColumns[sourceColumnIndex][sourceRowIndex];
    tempColumns[sourceColumnIndex][sourceRowIndex] =
      tempColumns[targetColumnIndex][targetRowIndex];

    tempColumns[targetColumnIndex][targetRowIndex] = tempSource;

    setColumns(tempColumns);
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setColumns([
      [sections.workExp,sections.project, sections.por],
      [sections.education, sections.skill, sections.course, sections.achievement],
    ]);
  }, []);
// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    swapSourceTarget(source, target);
  }, [source]);

  useEffect(() => {
    setStyles(props.template === "Two Column" ? stylesTwoColumn : stylesOneColumn);
  }, [props.template]);

  useEffect(() => {
    const container = containerRef.current;
    if (!props.activeColor || !container) return;

    container.style.setProperty("--color", props.activeColor);
  }, [props.activeColor]);

  return (
    <div ref={ref}>
      <div ref={containerRef} className={styles.resume} id="resume">
        <div className={styles.header}>
          <p className={styles.heading}>{info.basicInfo?.detail?.name}</p>
          <p className={styles.subHeading}>{info.basicInfo?.detail?.title}</p>

          <div className={styles.links}>
            {info.basicInfo?.detail?.email ? (
              <p className={styles.link} type="email">
                <AtSign className={styles.svg}/> {info.basicInfo?.detail?.email}
              </p>
            ) : (
              <span />
            )}
            {info.basicInfo?.detail?.phone ? (
              <p className={styles.link}>
                <Phone className={styles.svg}/> {info.basicInfo?.detail?.phone}
              </p>
            ) : (
              <span />
            )}
            {info.basicInfo?.detail?.linkedin ? (
              <a className={styles.link} href={info.basicInfo?.detail?.linkedin} target="_blank" rel="noreferrer">
                <Linkedin className={styles.svg}/> LinkedIn
              </a>
            ) : (
              <span />
            )}
            {info.basicInfo?.detail?.github ? (
              <a className={styles.link} href={info.basicInfo?.detail?.github} target="_blank" rel="noreferrer">
                <GitHub className={styles.svg}/> GitHub
              </a>
            ) : (
              <span />
            )}
          </div>
        </div>

        <div className={styles.main}>
          <div className={styles.col1}>
            {columns[0].map((item) => sectionDiv[item])}
          </div>
          <div className={styles.col2}>
            {columns[1].map((item) => sectionDiv[item])}
          </div>
        </div>
      </div>
    </div>
  );
});

export default Resume;
